module.exports = __webpack_public_path__ + "img/appAsset-quickstart--Preview.2c7762d2.svg";